import PropTypes from "prop-types"
import React, { useEffect, useMemo } from "react"
import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom"
import { connect } from "react-redux"
import { authRoutes, getUserRoutes, orderRoutes } from "./routes/allRoutes"
import Authmiddleware from "./routes/middleware/Authmiddleware"
import VerticalLayout from "./components/VerticalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"
import "./assets/scss/theme.scss"
import {
  ensureAuthUserData,
  getClientConfig,
  getFeaturesAvailable,
} from "store/actions"
import OrdersMiddleware from "routes/middleware/OrdersMiddleware"
import { LOCAL_STORAGE_TAGS, URL_PATHS } from "constants/index"
import { Spinner } from "reactstrap"
import Pages404 from "containers/UtilityPages/pages-404"

function App(props) {
  const Layout = VerticalLayout
  const isLoggedIn = !!localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER)

  useEffect(() => {
    props.ensureAuthUserData()
  }, [])

  useEffect(() => {
    if (props.vendorId) {
      props.getClientConfig({ vendor_id: props.vendorId })
      props.getFeaturesAvailable()
    }
  }, [props.vendorId])

  const isConfigLoaded = useMemo(() => {
    return (
      props.clientConfig &&
      Object.keys(props.clientConfig).length > 0 &&
      props.featuresAvailable &&
      props.featuresAvailable.length > 0
    )
  }, [props.clientConfig, props.featuresAvailable])

  const userRoutes = useMemo(() => {
    return getUserRoutes(props.clientConfig, props.featuresAvailable)
  }, [props.clientConfig, props.featuresAvailable])

  return (
    <React.Fragment>
      <div className="custom-overlay">
        <div className="custom-overlay-content">
          Please rotate your device to landscape mode to continue using the
          Admin Dashboard.
          <div>
            <br />
            <i className="bx bx-rotate-left" style={{ fontSize: "50px" }} />
          </div>
        </div>
      </div>
      <Router>
        <Switch>
          {/* public routes */}
          {authRoutes?.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
            />
          ))}

          {orderRoutes?.map((route, idx) => (
            <OrdersMiddleware
              key={idx}
              component={route.component}
              path={route.path}
            />
          ))}

          {/* protected routes */}
          {isLoggedIn && !isConfigLoaded && (
            <Route
              path="/"
              render={() => (
                <div className="p-2 my-1 text-center">
                  <Spinner className="ms-2" color="primary" />
                </div>
              )}
            />
          )}

          {isLoggedIn &&
            isConfigLoaded &&
            userRoutes?.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                layout={Layout}
                component={route.component}
                key={idx}
                isAuthProtected={true}
                exact
                userHasAccess={route.userHasAccess}
                configFetchInterval={30000}
                vendorId={props.vendorId}
                fetchConfigs={vendorId => {
                  props.getClientConfig({ vendor_id: vendorId })
                  props.getFeaturesAvailable()
                }}
              />
            ))}

          <Route
            render={() =>
              isLoggedIn ? <Pages404 /> : <Redirect to={URL_PATHS.LOGIN} />
            }
          />
        </Switch>
      </Router>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
    vendorId: state.Login.vendorId,
    featuresAvailable: state.Login.featuresAvailable,
    clientConfig: state.Login.clientConfig,
  }
}

export default connect(mapStateToProps, {
  ensureAuthUserData,
  getClientConfig,
  getFeaturesAvailable,
})(App)
